import { Dialog } from '@buffer-mono/popcorn'

import styles from './BulkPostDialog.module.css'

/**
 * Ensures the body of the dialog is shared by the different steps
 */
export const BulkPostDialogBody = ({
  children,
  title,
}: {
  children: React.ReactNode
  title: string
}): JSX.Element => {
  return (
    <Dialog.Body className={styles.body}>
      <Dialog.Title size="large">{title}</Dialog.Title>
      {children}
    </Dialog.Body>
  )
}
